import React, { createContext, useReducer, useContext } from 'react'
import { helocReducer, initialState } from './HelocReducer'

const HelocContext = createContext()

export function HelocProvider({ children, defaultValues }) {
  const [state, dispatch] = useReducer(helocReducer, {
    ...initialState,
    homesCurrentValue: defaultValues.homesCurrentValue,
    mortgageOutstandingBalance: defaultValues.mortgageOutstandingBalance,
    desiredLoanAmount: defaultValues.desiredLoanAmount,
    liveState: defaultValues.liveState,
    creditScore: defaultValues.creditScore,
  })

  return <HelocContext.Provider value={{ state, dispatch }}>{children}</HelocContext.Provider>
}

export function useHeloc() {
  return useContext(HelocContext)
}
